import { render, staticRenderFns } from "./UtilityTransaction.vue?vue&type=template&id=318c7e88&scoped=true&"
import script from "./UtilityTransaction.vue?vue&type=script&lang=js&"
export * from "./UtilityTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c7e88",
  null
  
)

export default component.exports